(function() {
  let clickedProductElement = null;
  const mainproductid = $('.custom-product-section').attr('data-main-product-id');
  console.log('Main Product ID:', mainproductid);

  $(document).ready(function(){
    $('.bundle-product-withoutborder-button').click(function(){
      clickedProductElement = $(this).closest('.bundle-product-li-block').attr('data-productId');
      $('.product-form__submit').trigger('click');
      console.log('Click success');
      console.log('Clicked Product Element:', clickedProductElement);
    });

    $('#myReportfile').on('change', function() {
      if ($(this).val() !== "") {
        $('.note-error').hide();
      }
    });

    $('.bundle-product-withoutborder-report-button').click(function(){
      if ($('#myReportfile').val() === "") {
        $('.note-error').show();
        $('html, body').animate({ scrollTop: 0 }, 'slow'); // Scroll to top when error message is displayed
      } else {
        clickedProductElement = $(this).closest('.bundle-product-li-block').attr('data-productId');
        $('.product-form__submit').trigger('click');
        console.log('Click success');
        console.log('Clicked Product Element:', clickedProductElement);
      }
    });
  });

  // Function to check if a product is in the cart and get its line number
  function getLineForItemId(productId) {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const item = cart.items.find(item => item.id == productId);
        return item ? cart.items.findIndex(i => i.id == item.id) + 1 : null; // Return line number (1-based index)
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
        return null; // Return null if there's an error
      });
  }

  // Function to remove an item from the cart using line number
  function removeItemFromCart(line) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(response => response.json())
    .catch(error => {
      console.error('Error removing item from cart:', error);
    });
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (this.cart) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const additionalProductQty = 1; // Example: Set the quantity of the additional product
        const bundleproductId = $('#hide_custom-bundle-product').val();

        if (mainproductid) {
          getLineForItemId(mainproductid).then(lineNumber => {
            if (lineNumber) {
              // Remove the existing product from the cart
              console.log('Removing existing product from cart, line number:', lineNumber);
              removeItemFromCart(lineNumber).then(() => {
                // After removing the product, add the new product
                console.log('Product removed from cart. Now adding new properties.');

                // Append the new properties and quantity
                formData.append('properties[_Box Id]', bundleproductId);

                if (clickedProductElement) {
                  const additionalProductId = clickedProductElement;
                  console.log('Additional Product ID:', additionalProductId);
                  // Append the additional product to the form data
                  formData.append('items[1][id]', additionalProductId);
                  formData.append('items[1][quantity]', additionalProductQty);
                  formData.append('items[1][properties][_Box Id]', bundleproductId);
                }

                // Log formData content for debugging
                for (let pair of formData.entries()) {
                  console.log(pair[0] + ': ' + pair[1]);
                }

                if (this.cart) {
                  formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
                  formData.append('sections_url', window.location.pathname);
                  this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                  .then(response => {
                    if (!response.ok) {
                      console.error('Error response:', response);
                      throw new Error('Network response was not ok');
                    }
                    return response.json();
                  })
                  .then(response => {
                    if (response.status) {
                      publish(PUB_SUB_EVENTS.cartError, {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                        errors: response.errors || response.description,
                        message: response.message,
                      });
                      this.handleErrorMessage(response.description);

                      const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                      if (soldOutMessage) {
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.submitButton.querySelector('span').classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                      }
                      return;
                    } else if (!this.cart) {
                      window.location = window.routes.cart_url;
                      return;
                    }

                    if (!this.error) {
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                        cartData: response
                      });
                      this.error = false;

                      const quickAddModal = this.closest('quick-add-modal');
                      if (quickAddModal) {
                        document.body.addEventListener('modalClosed', () => {
                          setTimeout(() => {
                            this.cart.renderContents(response);
                          });
                        }, { once: true });
                        quickAddModal.hide(true);
                      } else {
                        this.cart.renderContents(response);
                      }
                    }
                  })
                  .catch(e => {
                    console.error('Fetch error:', e);
                  })
                  .finally(() => {
                    this.submitButton.classList.remove('loading');
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                  });
              });
            } else {
              // If no existing item is found, just proceed to add the new product
              if (clickedProductElement) {
                const additionalProductId = clickedProductElement;
                console.log('Additional Product ID:', additionalProductId);
                // Append the additional product to the form data
                formData.append('items[1][id]', additionalProductId);
                formData.append('items[1][quantity]', additionalProductQty);
                formData.append('items[1][properties][_Box Id]', bundleproductId);
              }

              // Log formData content for debugging
              for (let pair of formData.entries()) {
                console.log(pair[0] + ': ' + pair[1]);
              }

              if (this.cart) {
                formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }
              config.body = formData;

              fetch(`${routes.cart_add_url}`, config)
                .then(response => {
                  if (!response.ok) {
                    console.error('Error response:', response);
                    throw new Error('Network response was not ok');
                  }
                  return response.json();
                })
                .then(response => {
                  if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      errors: response.errors || response.description,
                      message: response.message,
                    });
                    this.handleErrorMessage(response.description);

                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (soldOutMessage) {
                      this.submitButton.setAttribute('aria-disabled', true);
                      this.submitButton.querySelector('span').classList.add('hidden');
                      soldOutMessage.classList.remove('hidden');
                      this.error = true;
                    }
                    return;
                  } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }

                  if (!this.error) {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      cartData: response
                    });
                    this.error = false;

                    const quickAddModal = this.closest('quick-add-modal');
                    if (quickAddModal) {
                      document.body.addEventListener('modalClosed', () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      }, { once: true });
                      quickAddModal.hide(true);
                    } else {
                      this.cart.renderContents(response);
                    }
                  }
                })
                .catch(e => {
                  console.error('Fetch error:', e);
                })
                .finally(() => {
                  this.submitButton.classList.remove('loading');
                  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                  this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                });
            }
          });
        } else {
          // If mainproductid is not defined, just proceed to add the new product
          if (clickedProductElement) {
            const additionalProductId = clickedProductElement;
            console.log('Additional Product ID:', additionalProductId);
            // Append the additional product to the form data
            formData.append('items[1][id]', additionalProductId);
            formData.append('items[1][quantity]', additionalProductQty);
            formData.append('items[1][properties][_Box Id]', bundleproductId);
          }

          // Log formData content for debugging
          for (let pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
          }

          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then(response => {
              if (!response.ok) {
                console.error('Error response:', response);
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(response => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (soldOutMessage) {
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButton.querySelector('span').classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                }
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response
                });
                this.error = false;

                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener('modalClosed', () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  }, { once: true });
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
              }
            })
            .catch(e => {
              console.error('Fetch error:', e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          // Scroll to the top of the page
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // Smooth scroll to the top
          });
        }
      }
    });
  }
})();
